import { useRouter } from "@edreamsodigeo/frontend-core";

const useGetTripTokenFromUrl = (): string => {
  const { pathname } = useRouter();

  try {
    if (pathname.length > 2000) return "";

    const tdIndex = pathname.indexOf("td=");
    if (tdIndex === -1) return "";

    const startIndex = tdIndex + 3;
    let endIndex = pathname.length;

    const delimiters = [",", ";", ":", "%", "?", "&", "/", "#"];
    for (const delimiter of delimiters) {
      const delimiterIndex = pathname.indexOf(delimiter, startIndex);
      if (delimiterIndex !== -1 && delimiterIndex < endIndex) {
        endIndex = delimiterIndex;
      }
    }

    const token = pathname.slice(startIndex, endIndex);

    if (
      token.length === 0 ||
      token.length > 1000 ||
      !/^[A-Za-z0-9_-]+$/.test(token)
    ) {
      return "";
    }

    return token;
  } catch (error) {
    return "";
  }
};

export default useGetTripTokenFromUrl;
